export default {
    white: '#FFF',
    tableOddColor: '#1a1a1a',
    containerColor: '#111111',
    darkText: 'rgba(255, 255, 255, 0.87)',
    headerText: '#aaaaaa',
    affirmative: '#333333',
    customInactiveButton: '#444444',
    lightGray: '#222222',
    inputBorder: '#333333',
    mediumGray: '#cccccc',
    mediumGrayDisabled: '#666666',
    success: '#1DB954',
    successDisabled: '#62fc98',
    danger: '#FF5A60',
    dangerDisabled: '#f97c81',
    warning: '#ffc107',
    warningDisabled: '#ffdb72',
    lightOrange: "#ffffff",
    lightPaleBlue: "#ADD8E6",
    success: "#4BB543"
  };
  